import { Routes, Route, useLocation } from "react-router-dom"
import { AnimatePresence, motion } from "framer-motion"
import { LanguageProvider } from "./shared/context/LanguageContext"
import { Home } from "./pages/Home"
import { Header } from "./shared/components/Header"
import { Footer } from "./shared/components/Footer"
import { OurClient } from "./pages/OurClient"
import { AboutUs } from "./pages/AboutUs"
import { pageTransition } from "./shared/lib/motion"
import { PrivacyPolicy } from "./pages/PrivacyPolicy"
import { TermsConditions } from "./pages/TermsConditions"
import { DownloadApp } from "./pages/DownloadApp"
import InTheNews from "./pages/InTheNews"
import { useEffect } from "react"
import { FAQ } from "./pages/FAQ"

export default function App() {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" })
  }, [location.pathname])


  useEffect(() => {
    fetch('https://ipinfo.io/json')
      .then(r => r.json())
      .then(data => {
        if (data.country === 'SA') {
          window.location.href = 'https://www.google.com'
        }
      })
      .catch(() => {})
  }, [])

  return (
    <LanguageProvider>
      <div className="min-h-screen page-enter">
        <Header />
        <div className="sm:hidden sticky top-0 left-0 w-full h-[20.5px] bg-white z-50"></div>
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            variants={pageTransition}
            initial="hidden"
            animate="show"
            exit="exit"
          >
            <Routes location={location}>
              <Route path="/" element={<Home />} />
              <Route path="/our-client" element={<OurClient />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-conditions" element={<TermsConditions />} />
              <Route path="/download" element={<DownloadApp />} />
              <Route path="/in-the-news" element={<InTheNews />} />
            </Routes>
          </motion.div>
        </AnimatePresence>
        {location.pathname !== "/download" && <Footer />}
      </div>
    </LanguageProvider>
  )
}

